import type { MessageSchema } from './en'

const es: MessageSchema = {
  common: {
    cancel: 'Cancelar',
    create: 'Crear',
    save: 'Guardar',
    saving: 'Guardando…',
    refresh: 'Actualizar',
    loading: 'Cargando…'
  },
  nav: {
    products: 'Productos',
    upload: 'Cargar',
    adhoc: 'Ad hoc',
    reports: 'Informes',
    settings: 'Configuración'
  },
  sidebar: {
    expand: 'Expandir',
    collapse: 'Contraer',
    expandSidebar: 'Expandir la barra lateral',
    collapseSidebar: 'Contraer la barra lateral',
    logout: 'Cerrar sesión'
  },
  topbar: {
    welcome: 'Bienvenido, {name}',
    selectLanguage: 'Seleccionar idioma'
  },
  footer: {
    copyright: 'Copyright © {year} Avalara Inc. Todos los derechos reservados.'
  },
  auth: {
    redirecting: 'Redirigiendo al inicio de sesión…',
    completing: 'Completando la autenticación…',
    noCode: 'No se recibió ningún código de autorización',
    failed: 'Error de autenticación. Inténtelo de nuevo.',
    tryAgain: 'Reintentar'
  },
  settings: {
    profiles: 'Perfiles',
    users: 'Usuarios'
  },
  reporting: {
    userTitle: 'Informes de usuario',
    userSubtitle: 'Consulte y descargue los informes relacionados con su actividad',
    userEmpty: 'No hay informes disponibles en este momento.',
    profileTitle: 'Informes de perfil',
    profileSubtitle: 'Consulte y descargue los informes relacionados con la actividad de su perfil',
    profileEmpty: 'No hay informes de perfil disponibles en este momento.',
    loading: 'Cargando informes…',
    emptyTitle: 'No hay informes disponibles',
    download: 'Descargar',
    loadFailed: 'Error al cargar los informes'
  },
  eccn: {
    title: 'Clasificación ECCN de autoservicio',
    subtitle: 'Introduzca la descripción de su producto para obtener una clasificación ECCN automatizada',
    productLabel: 'Descripción del producto',
    productPlaceholder: 'Introduzca una descripción detallada del producto, sus especificaciones y su uso previsto…',
    descriptionRequired: 'Introduzca una descripción del producto',
    clear: 'Borrar',
    classify: 'Clasificar producto',
    classifying: 'Clasificando…',
    resultTitle: 'Resultado de la clasificación',
    confidence: '{value} % de confianza',
    code: 'ECCN',
    description: 'Descripción',
    controlReason: 'Motivo de control',
    exportRestrictions: 'Restricciones de exportación',
    noRestrictions: 'Sin restricciones específicas',
    downloadReport: 'Descargar informe',
    saveClassification: 'Guardar clasificación',
    readyTitle: 'Listo para clasificar',
    readyHint: 'Introduzca una descripción del producto y haga clic en «{action}» para comenzar'
  },
  dashboard: {
    totalProducts: 'Total de productos',
    totalProductsChange: '+12 % respecto al mes pasado',
    classifications: 'Clasificaciones',
    classificationsChange: 'Productos verificados hoy',
    activeUsers: 'Usuarios activos',
    activeUsersChange: 'En línea ahora',
    complianceRate: 'Tasa de cumplimiento',
    complianceRateChange: '+2,1 % de mejora',
    quickUpload: 'Carga rápida',
    quickUploadHint: 'Cargue y clasifique nuevos productos rápidamente',
    dropFiles: 'Arrastre y suelte sus archivos aquí',
    browseFiles: 'Examinar archivos',
    recentActivity: 'Actividad reciente',
    recentActivityHint: 'Últimas actividades de clasificación',
    classifiedSuccessfully: 'Clasificado correctamente',
    pendingReview: 'Pendiente de revisión',
    hoursAgo: 'hace {count} h',
    daysAgo: 'hace {count} d',
    systemStatus: 'Estado del sistema',
    systemStatusHint: 'Estado actual de los servicios de cumplimiento comercial',
    serviceClassificationApi: 'API de clasificación',
    serviceFileUpload: 'Carga de archivos',
    serviceReporting: 'Informes',
    operational: 'Operativo',
    issues: 'Incidencias'
  },
  profiles: {
    addChild: 'Añadir perfil secundario',
    idLabel: 'ID: {id}',
    information: 'Información del perfil',
    nameLabel: 'Nombre del perfil',
    namePlaceholder: 'Introduzca el nombre del perfil',
    parentIdLabel: 'ID principal',
    noParent: 'Ninguno (raíz)',
    save: 'Guardar perfil',
    emptyTitle: 'Seleccione un perfil',
    emptyHint: 'Seleccione un perfil del árbol para ver y editar sus detalles',
    createTitle: 'Crear perfil secundario',
    loadFailed: 'Error al cargar los perfiles',
    detailsFailed: 'Error al cargar los detalles del perfil',
    saved: 'Perfil guardado correctamente',
    saveFailed: 'Error al guardar el perfil',
    nameRequired: 'Indique un nombre de perfil',
    created: 'Perfil creado correctamente',
    duplicateName: 'Ya existe un perfil con este nombre',
    createFailed: 'Error al crear el perfil'
  },
  users: {
    count: '{count} usuario | {count} usuarios',
    addNew: 'Añadir usuario',
    edit: 'Editar usuario',
    username: 'Nombre de usuario',
    email: 'Correo electrónico',
    firstName: 'Nombre',
    lastName: 'Apellidos',
    role: 'Rol',
    roleUser: 'Usuario',
    roleAdmin: 'Administrador',
    status: 'Estado',
    active: 'Activo',
    inactive: 'Inactivo',
    lastLogin: 'Último inicio de sesión',
    lastLogout: 'Último cierre de sesión',
    assignedProfiles: 'Perfiles asignados',
    loadingProfiles: 'Cargando perfiles…',
    resetPassword: 'Restablecer contraseña',
    loadFailed: 'Error al cargar los usuarios',
    requiredFields: 'El nombre de usuario, el nombre y el correo electrónico son obligatorios',
    profileRequired: 'Seleccione al menos un perfil',
    usernameExists: 'El nombre de usuario ya existe',
    saved: 'Usuario guardado correctamente',
    saveFailed: 'Error al guardar el usuario',
    passwordReset: 'Contraseña restablecida correctamente',
    passwordResetFailed: 'Error al restablecer la contraseña'
  },
  upload: {
    colUploaded: 'Cargado',
    colClient: 'Cliente',
    colProfile: 'Perfil',
    colDescription: 'Descripción',
    colFileName: 'Nombre del archivo',
    colQuantity: 'Cantidad',
    colStatus: 'Estado',
    colErrors: 'Errores',
    stateNew: 'Nuevo',
    statePending: 'Pendiente',
    stateRunning: 'En ejecución',
    stateProcessing: 'Procesando',
    stateCompleted: 'Completado',
    stateError: 'Error',
    countProcessed: 'Procesados: {processed} de {total}',
    countSuccess: 'Correctos: {count}',
    countErrors: 'Errores: {count}',
    countWarnings: 'Advertencias: {count}',
    configTitle: 'Configuración de la carga',
    configSubtitle: 'Configure los ajustes de la carga',
    clientLabel: 'Cliente',
    clientPlaceholder: 'Nombre del cliente',
    profileLabel: 'Perfil',
    profilePlaceholder: 'Seleccione un perfil…',
    descriptionLabel: 'Descripción',
    descriptionPlaceholder: 'Introduzca una descripción para esta carga…',
    destinationsLabel: 'Destinos',
    destinationsPlaceholder: 'Seleccione destinos…',
    duplicateStrategy: 'Estrategia de duplicados',
    overwriteDuplicates: 'Sobrescribir duplicados',
    ignoreDuplicates: 'Ignorar duplicados',
    actionsLabel: 'Acciones',
    classification: 'Clasificación',
    fileTitle: 'Carga de archivos',
    fileSubtitle: 'Arrastre y suelte o seleccione los archivos que desea cargar',
    dropTitle: 'Arrastre y suelte sus archivos aquí',
    formatHint: 'Debe estar en formato Excel (.xlsx). Para descargar una plantilla de ejemplo,',
    clickHere: 'haga clic aquí',
    headerRowHint: 'La primera fila del archivo se reserva como fila de encabezado',
    selectFile: 'Seleccionar archivo para cargar',
    selectAll: 'Seleccionar todo',
    deselectAll: 'Deseleccionar todo',
    uploadedFiles: 'Archivos cargados',
    autoRefresh: 'Actualización automática',
    confirmTitle: 'Confirmar carga',
    confirmBody: 'Este archivo se cargará en {profile}. ¿Está seguro?',
    uploadAction: 'Cargar',
    listFailed: 'Error al cargar la lista de archivos',
    xlsxOnly: 'Solo se permiten archivos .xlsx',
    tooLarge: 'El tamaño del archivo debe ser inferior a 10 MB',
    processingStarted: 'Guardando el archivo e iniciando el procesamiento…',
    saved: 'Archivo guardado, se procesará en breve',
    uploadFailed: 'Error al cargar el archivo',
    templateFailed: 'Error al descargar la plantilla'
  },
  reports: {
    userLabel: 'Usuario',
    profileLabel: 'Perfil',
    from: 'Desde',
    to: 'Hasta',
    exporting: 'Exportando…',
    exportDetails: 'Exportar detalles',
    productStatistics: 'Estadísticas de productos',
    addedProducts: 'Productos añadidos:',
    attemptedClassifications: 'Clasificaciones intentadas:',
    classified: 'Clasificados:',
    unclassified: 'Sin clasificar:',
    classifiedLabel: 'Clasificados',
    noData: 'No hay datos disponibles',
    noDataShort: 'Sin datos',
    classificationsOverTime: 'Clasificaciones a lo largo del tiempo',
    totalAttempted: 'Total de clasificaciones intentadas:',
    classificationsTooltip: '{count} clasificaciones',
    topItems: 'Top 5 de artículos',
    topItemsHint: 'Los 5 principales artículos de todos los productos',
    topCategories: 'Top 5 de categorías',
    topCategoriesHint: 'Las 5 principales categorías de productos sin clasificar',
    topCodes: 'Top 5 de códigos',
    topCodesHint: 'Los 5 principales códigos de productos clasificados',
    exported: 'Informe exportado correctamente',
    exportFailed: 'Error al exportar el informe'
  },
  adhoc: {
    title: 'Clasificación de productos',
    subtitle: 'Introduzca los datos del producto para obtener al instante una clasificación de código SA.',
    descriptionLabel: 'Descripción',
    descriptionPlaceholder: 'Describa el producto aquí…',
    descriptionHelp: 'Proporcione una descripción detallada del producto, incluidos los materiales, la finalidad y las características principales.',
    originLabel: 'Origen',
    originPlaceholder: 'Seleccione un origen…',
    destinationLabel: 'Destino',
    destinationPlaceholder: 'Seleccione un destino…',
    classify: 'Clasificar',
    classifying: 'Clasificando…',
    reset: 'Restablecer',
    tipsTitle: 'Consejos de clasificación',
    tipsBestResults: 'Para obtener mejores resultados:',
    tipMaterial: 'Incluya la composición de los materiales',
    tipUse: 'Especifique el uso o la función previstos',
    tipCharacteristics: 'Mencione las características físicas principales',
    tipBrand: 'Incluya la marca o el modelo si procede',
    tipsExamples: 'Ejemplos habituales:',
    exampleShirt: 'Camiseta de algodón para hombre, talla L',
    exampleKnife: 'Cuchillo de cocina de acero inoxidable, 8 pulgadas',
    exampleBattery: 'Batería de iones de litio para smartphones',
    exampleTable: 'Mesa de comedor de madera de roble, 6 plazas',
    fieldDescription: 'descripción del producto',
    fieldOrigin: 'origen',
    fieldDestination: 'destino',
    missingFields: 'Complete todos los campos obligatorios: {fields}',
    classificationTitle: 'Clasificación',
    classificationTitleFor: 'Clasificación: {description}',
    completed: 'Clasificación completada',
    completedCreateRule: 'Clasificación completada. Cree su regla ahora.',
    classifierNotStarted: 'La ventana de clasificación no se cargó. Haga clic para volver a intentarlo.',
    missingHsCode: 'Falta el código SA para la cotización',
    quoteTitle: 'Cotización de aranceles e impuestos',
    quoteConfirmHeading: '¿Desea calcular los aranceles e impuestos?',
    quoteConfirmBody: 'Esto le permitirá calcular los aranceles e impuestos estimados del producto clasificado.',
    classificationSummary: 'Resumen de la clasificación',
    hsCodeLabel: 'Código SA:',
    originValueLabel: 'Origen:',
    destinationValueLabel: 'Destino:',
    stackedHsCodes: 'Códigos SA acumulados:',
    noCancel: 'No, cancelar',
    yesContinue: 'Sí, continuar',
    quoteParamsTitle: 'Introducir los parámetros de cotización',
    classificationDetails: 'Detalles de la clasificación',
    optionalParameters: 'Parámetros opcionales',
    shipmentType: 'Tipo de envío',
    adValorem: 'Ad valorem',
    specific: 'Específico',
    currency: 'Moneda',
    countryOfOrigin: 'País de origen',
    selectCoo: 'Seleccione el país de origen…',
    quantity: 'Cantidad',
    unitValue: 'Valor unitario ($)',
    total: 'Total ($)',
    shipping: 'Envío ($)',
    handling: 'Manipulación ($)',
    insurance: 'Seguro ($)',
    measureValue: 'Valor de medida',
    unit: 'Unidad',
    calculating: 'Calculando…',
    getQuote: 'Obtener cotización',
    quoteResultsTitle: 'Resultados de la cotización de aranceles e impuestos',
    quoteSummary: 'Resumen de la cotización',
    quoteIdLabel: 'ID de cotización:',
    typeLabel: 'Tipo:',
    shipmentLabel: 'Envío:',
    currencyLabel: 'Moneda:',
    lineHeading: 'Línea {number} - {description}',
    hsBadge: 'SA: {code}',
    duties: 'Aranceles',
    taxes: 'Impuestos',
    colDescription: 'Descripción',
    colAmount: 'Importe',
    colType: 'Tipo',
    colTarget: 'Destino',
    colRate: 'Tasa',
    dutyDetails: 'Detalle de aranceles y aplicación del código SA',
    rateLabel: 'Tasa:',
    methodLabel: 'Método:',
    labelLabel: 'Etiqueta:',
    totalDuty: 'Total de aranceles',
    totalTax: 'Total de impuestos',
    grandTotal: 'Total general',
    disclaimerLabel: 'Aviso legal:',
    disclaimerBody: 'Estas estimaciones tienen carácter meramente informativo y pueden no reflejar los aranceles e impuestos aplicados realmente en la importación.',
    close: 'Cerrar'
  },
  products: {
    tabDetails: 'Detalles',
    tabDestinations: 'Destinos',
    tabHistory: 'Historial',
    tabAudit: 'Auditoría',
    tabCopy: 'Copiar',
    colDate: 'Fecha',
    colId: 'ID',
    colProfile: 'Perfil',
    colDescription: 'Descripción',
    colCustomsDesc: 'Desc. aduanera',
    colItem: 'Artículo',
    colCategory: 'Categoría',
    colDutyRates: 'Tasas arancelarias',
    productId: 'ID del producto',
    description: 'Descripción',
    customsDescription: 'Descripción aduanera',
    client: 'Cliente',
    source: 'Origen de los datos',
    origin: 'Origen',
    selectOrigin: 'Seleccione un origen…',
    manufacturerName: 'Nombre del fabricante',
    reclassify: 'Reclasificar',
    classify: 'Clasificar',
    reset: 'Restablecer',
    save: 'Guardar',
    selectProductDetails: 'Seleccione un producto para ver sus detalles',
    tariffPackageRequired: 'Para acceder a esta función necesita el paquete de datos de contenido arancelario.',
    destination: 'Destino',
    selectDestination: 'Seleccione un destino…',
    hsCode: 'Código SA',
    lookupTariffCode: 'Buscar código arancelario',
    tariffCode: 'Código arancelario',
    addTariffCode: 'Añadir código arancelario',
    viewCompliance: 'Ver detalles de cumplimiento',
    removeDestination: 'Eliminar destino',
    valid: 'Válido',
    invalid: 'No válido',
    restrictions: 'Restricciones',
    selectProductDestinations: 'Seleccione un producto para ver sus destinos',
    noHistory: 'No hay historial disponible',
    questions: 'Preguntas',
    rationale: 'Justificación',
    hsVersion: 'Versión SA',
    noAudit: 'No hay información de auditoría disponible',
    copyFields: 'Copiar campos',
    copyTo: 'Copiar a',
    checkedProducts: 'Los productos que he marcado',
    allListedProducts: 'Todos los productos mostrados actualmente',
    productCount: '{count} productos',
    whenDataExists: 'Cuando ya existen datos',
    overwrite: 'Sobrescribir los datos existentes',
    doNotOverwrite: 'No sobrescribir los datos existentes',
    copying: 'Copiando…',
    copy: 'Copiar',
    selectProductCopy: 'Seleccione un producto para configurar las opciones de copia',
    loadingProduct: 'Cargando la información del producto…',
    matching: 'Coincidencias: {count}',
    checked: 'Marcados: {count}',
    exportAction: 'Exportar',
    reclassifyAction: 'Reclasificar',
    addProduct: 'Añadir producto',
    filters: 'Filtros',
    newProduct: 'Nuevo producto',
    productIdRequired: 'El ID del producto es obligatorio.',
    descriptionRequired: 'La descripción es obligatoria.',
    profile: 'Perfil',
    selectProfile: 'Seleccione un perfil…',
    reclassifyTitle: 'Reclasificar productos',
    reclassifyConfirm: '¿Seguro que desea reclasificar {count} productos?',
    reclassifyNeedsSelection: 'Marque primero los productos que desea reclasificar',
    reclassifyScopeQuestion: '¿Qué productos desea reclasificar?',
    reclassifyScopeChecked: 'Solo los productos que he marcado',
    reclassifyScopeAll: 'Todos los productos del filtro, en todas las páginas',
    reclassifyWarning: 'Esto puede afectar a otros usuarios hasta que finalice el proceso.',
    reclassifyProgress: 'Reclasificando productos… {count}',
    processing: 'Procesando…',
    complianceTitle: 'Información de cumplimiento',
    add: 'ADD',
    cvd: 'CVD',
    pga: 'PGA',
    yes: 'SÍ',
    no: 'NO',
    mfnRate: 'Tasa NMF',
    exportTitle: 'Exportar productos',
    exportConfirm: '¿Desea exportar a Excel la lista actual de productos (según los filtros activos)?',
    exportHint: 'El archivo se generará y su navegador iniciará la descarga automáticamente.',
    preparingExcel: 'Preparando el archivo de Excel. Su navegador iniciará la descarga en breve.',
    dutyRatesTitle: 'Tasas arancelarias',
    loadingDutyRates: 'Cargando las tasas arancelarias…',
    dutyRateDetails: 'Detalle de las tasas arancelarias',
    noDetailedDutyRates: 'No hay tasas arancelarias detalladas disponibles.',
    noDutyRates: 'No hay tasas arancelarias disponibles para este producto.',
    classifiedHsVersion: 'Clasificado / Versión SA',
    all: 'Todos',
    classified: 'Clasificados',
    notClassified: 'Sin clasificar',
    hsYear: 'Año SA',
    item: 'Artículo',
    category: 'Categoría',
    fromTo: 'Desde / Hasta',
    search: 'Buscar',
    dutyRatesFailed: 'Error al cargar las tasas arancelarias',
    detailsFailed: 'Error al cargar los detalles del producto',
    saved: 'Producto guardado correctamente',
    saveFailed: 'Error al guardar el producto',
    profileNotReady: 'El perfil de usuario no está listo para la copia',
    noCopyTargets: 'No se han seleccionado productos de destino para la copia',
    noCopySources: 'No hay campos de origen disponibles para copiar',
    copied: 'Campos copiados correctamente',
    copyFailed: 'Error al copiar los campos a los productos',
    copyStillRunning: 'La copia no ha terminado y puede seguir ejecutándose en el servidor. Revise los productos antes de copiar de nuevo.',
    copyLeaveConfirm: 'Hay una copia en curso. Si sale de esta página, continúa en el servidor, pero no verá si se completó. ¿Salir de todos modos?',
    createRequiredFields: 'El ID del producto y la descripción son obligatorios',
    created: 'Producto creado correctamente',
    createFailed: 'Error al crear el producto',
    classifyRequirements: 'Se requiere una descripción aduanera o un código SA existente para clasificar este producto',
    classifying: 'Clasificando el producto…',
    noHsCode: 'El clasificador no devolvió ningún código SA',
    noHsYear: 'La clasificación se devolvió sin información del año SA',
    classifiedOk: 'Producto clasificado correctamente',
    classifyCancelled: 'Clasificación cancelada o fallida',
    classifierNotStarted: 'La ventana de clasificación no se cargó. Haga clic para volver a intentarlo.',
    reclassifyStarted: 'Reclasificación iniciada',
    reclassifyFailed: 'Error al iniciar la reclasificación',
    exportFailed: 'Error de exportación',
    complianceFailed: 'Error al cargar los datos de cumplimiento',
    tariffSaved: 'Código arancelario guardado',
    tariffSaveFailed: 'Error al guardar el código arancelario',
    tariffSuggested: 'Código arancelario sugerido por el clasificador',
    noTariffCode: 'El clasificador no devolvió ningún código arancelario',
    tariffLookupFailed: 'Error en la búsqueda del código arancelario',
    deletingDestination: 'Eliminando el destino {destination}…',
    destinationDeleted: 'Destino eliminado',
    destinationDeleteFailed: 'Error al eliminar el destino'
  },
  rules: {
    title: 'Reglas de clasificación',
    subtitle: 'Consulte las reglas de clasificación guardadas que rellenan automáticamente las respuestas durante la clasificación de productos.',
    count: 'Tiene {count} reglas',
    create: 'Crear regla',
    classifyFirst: 'Clasifique primero un producto para crear una regla.',
    filterPlaceholder: 'Filtrar por nombre o artículo…',
    filterAria: 'Filtrar reglas',
    rowHint: 'Haga clic en una fila para ver los detalles de la regla',
    colRuleName: 'Nombre de la regla',
    colItem: 'Artículo',
    colSip: 'SIP',
    detailsTitle: 'Detalles de la regla',
    ruleNameLabel: 'Nombre de la regla:',
    itemLabel: 'Artículo:',
    sipLabel: 'SIP:',
    constraints: 'Restricciones',
    constraintsCaption: 'Restricciones de la regla seleccionada',
    colCategory: 'Categoría',
    colType: 'Tipo',
    colValues: 'Valores',
    typeSelection: 'Selección',
    typeValued: 'Valorado',
    deleting: 'Eliminando…',
    deleteRule: 'Eliminar regla',
    close: 'Cerrar',
    createTitle: 'Crear regla de clasificación',
    ruleNameField: 'Nombre de la regla',
    ruleNamePlaceholder: 'p. ej. Camisetas de algodón',
    itemNameField: 'Nombre del artículo',
    itemNamePlaceholder: 'p. ej. Camiseta',
    sipField: 'SIP',
    sipPlaceholder: 'p. ej. 6109.10',
    hsCodeLabel: 'Código SA:',
    originLabel: 'Origen:',
    destinationLabel: 'Destino:',
    interactions: 'Interacciones',
    selectAll: 'Seleccionar todo',
    unselectAll: 'Deseleccionar todo',
    selectedCount: 'Interacciones seleccionadas: {count}',
    ruleApplied: 'Regla aplicada',
    ruleMismatch: 'Discrepancia de regla',
    category: 'Categoría',
    type: 'Tipo',
    values: 'Valores',
    select: 'Seleccionar',
    deleteTitle: 'Eliminar regla',
    deleteConfirm: 'Esta acción no se puede deshacer. ¿Eliminar {name}?',
    delete: 'Eliminar',
    classifyBeforeCreate: 'Clasifique un producto antes de crear una regla.',
    noProfile: 'No hay ningún perfil seleccionado para las operaciones con reglas',
    requiredFields: 'El nombre de la regla, el artículo y el SIP son obligatorios',
    selectInteraction: 'Seleccione al menos una interacción',
    itemInteractionRequired: 'Esta regla no se puede guardar sin seleccionar la interacción del artículo.',
    selectOneOption: 'Seleccione una opción para «{label}»',
    enterValues: 'Introduzca valores para «{label}»',
    valuesMustTotal: 'Los valores de «{label}» deben sumar 100 %',
    created: 'Regla creada correctamente',
    createFailed: 'Error al crear la regla',
    deleted: 'Regla eliminada correctamente',
    deleteFailed: 'Error al eliminar la regla'
  },
  table: {
    noData: 'No hay datos disponibles',
    downloadErrorFile: 'Descargar el archivo de errores',
    showing: 'Mostrando {from} - {to} de {total}',
    perPage: '{size} por página',
    requiresAccess: 'Esta función requiere acceso adicional'
  },
  header: {
    greeting: 'Hola {name}'
  }
}

export default es
